import { Component, DestroyRef, inject, Signal } from '@angular/core';
import { NotificationService } from '../../services/notifications/notification.service';
import { INotification } from '../../interfaces/notification.interface';
import { DatePipe, NgOptimizedImage, NgClass } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconCheckComponent } from "../icons/icon-check/icon-check.component";
import { IconClockComponent } from "../icons/icon-clock/icon-clock.component";
import { IconInfosComponent } from "../icons/icon-infos/icon-infos.component";
import { IconNotificationBellComponent } from "../icons/icon-notification-bell/icon-notification-bell.component";

@Component({
  selector: 'braidsbook-notifications',
  imports: [IconCheckComponent, DatePipe, NgClass, IconClockComponent, IconNotificationBellComponent],
  templateUrl: './notifications.component.html',
  styles: `
    .line-clamp-2 {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  `
})
export class NotificationsComponent {
  #notificationsService: NotificationService = inject(NotificationService);
  #destroyRef: DestroyRef = inject(DestroyRef);

  notifications: Signal<INotification[]> = this.#notificationsService.notifications;
  unreadCount: Signal<number> = this.#notificationsService.unreadCount;
  loading: Signal<boolean> = this.#notificationsService.loading;

  isOpen = false;

  constructor() {
    // Charger les notifications au démarrage
    this.#notificationsService.getAllNotifications()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe();
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  closeDropdown(): void {
    this.isOpen = false;
  }

  refresh(): void {
    this.#notificationsService.refresh();
  }

  markAsRead(notificationId: string): void {
    this.#notificationsService.markAsRead(notificationId)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe();
  }

  markAsUnread(notificationId: string): void {
    this.#notificationsService.markAsUnread(notificationId)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe();
  }

  markAllAsRead(): void {
    const unreadNotifications = this.notifications().filter(n => !n.isRead);
    unreadNotifications.forEach(notification => {
      this.markAsRead(notification.id);
    });
  }

  getNotificationIcon(type: string): string {
    switch (type) {
      case 'reservation': return '📅';
      case 'payment': return '💳';
      case 'cancellation': return '❌';
      case 'reminder': return '⏰';
      default: return 'ℹ️';
    }
  }

  getNotificationIconClass(type: string): string {
    switch (type) {
      case 'reservation': return 'bg-blue-100 text-blue-600';
      case 'payment': return 'bg-green-100 text-green-600';
      case 'cancellation': return 'bg-red-100 text-red-600';
      case 'reminder': return 'bg-yellow-100 text-yellow-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  }
}
